import { render, staticRenderFns } from "./EinstellungenKorrespondenz.vue?vue&type=template&id=3ae38ec0&"
import script from "./EinstellungenKorrespondenz.vue?vue&type=script&lang=js&"
export * from "./EinstellungenKorrespondenz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports